export enum MotionCount0_25 {
  dominant = "#fffbfb",
  median = "#fff9ea",
  shade = "#f1fddb",
}

export enum MotionCount26_50 {
  dominant = "#ffcbcb",
  median = "#f9e5b6",
  shade = "#e2f1c5",
}

export enum MotionCount51_75 {
  dominant = "#f96464",
  median = "#f9e5b6",
  shade = "#e2f1c5",
}

export enum MotionCount75_ {
  dominant = "#ff0000",
  median = "#f9e5b6",
  shade = "#e2f1c5",
}

export enum Shadow {
  Transparent = "rgba(255, 183, 183, 0)",
}

// new setup

// floorplan colors
export const floorplanColors = {
  border: "#666f76",
  fault: "#f90b0b",
  lightOff: "#d9d9d9",
  lightOn: "#198754",
  selected: "#ffc107",
};

// update Floorplan colors
export const lightOffColors = {
  border: "#666f76",
  offFaultImageFile: "#f90b0b",
  offInitialImageFile: "#d9d9d9",
  offOnlineImageFile: {
    color: "#d9d9d9",
    border: "#198050",
  },
  offOfflineImageFile: "#d9d9d9",
};

export const lightOnColors = {
  border: "#666f76",
  onFaultImageFile: "#f90b0b",
  onInitialImageFile: "#d9d9d9",
  onOnlineImageFile: "#198754",
  onOfflineImageFile: {
    color: "#d9d9d9",
    border: "#198050",
  },
};

// heatmap colors

export const heatmapColors = {
  selected: [0, "rgba(255, 213, 79, 1)", 1, "rgba(255, 213, 79, 0.7)"], // Highlighted asset gradient (yellow)
  motion0to25: [0, "rgba(205, 190, 136, 0.8)", 1, "rgba(147, 144, 138, 0.9)"], // Gradient for 0-25
  motion26to50: [0, "rgba(255, 0, 0, 1)", 1, "rgba(255, 98, 0, 0.2)"], // Gradient for 26-50 (yellow)
  motion51to75: [0, "rgba(255, 0, 0, 1)", 1, "rgba(156, 86, 10, 0.6)"], // Gradient for 51-75 (orange)
  motionMoreThan75: [0, "rgba(255, 0, 0, 1)", 1, "rgba(177, 2, 2, 0.9)"], // Gradient for >75 (red)
  border: "#9f8f8f", // Circle border color
};

export const AnalyticsChartDataTypes = {
  Chart: 1,
  Animation: 2,
};
